import type { LoaderOptions } from '@/loaders/LoaderOptions';

import { getIndividualProductsQueryOptions, unitByIdQueryOptions } from '@/service/vpc/queryOptions';
import { chassis } from '@/utils';

export const loaderUnitCoveragePage = async (opts: LoaderOptions) => {
  const { endCustomerUnitId } = opts.params;

  if (!endCustomerUnitId) {
    return;
  }

  // First fetch the unit data to get serial numbers and chassis IDs
  const unitData = await opts.context.queryClient.ensureQueryData(unitByIdQueryOptions({ endCustomerUnitId }));

  // Extract serial numbers and chassis IDs from the unit data
  const serialNumbers = chassis.getUnitSerialNumbers(unitData) || [];
  // const chassisIds = chassis.getUnitsChassisIds(unitData) || [];

  // Prefetch products and operating hours data in parallel
  const prefetchPromises = [];

  if (serialNumbers.length > 0) {
    prefetchPromises.push(
      opts.context.queryClient.ensureQueryData(getIndividualProductsQueryOptions({ serialNumbers }))
    );
  }

  if (prefetchPromises.length > 0) {
    await Promise.all(prefetchPromises);
  }
};
